import React from "react";

const LOGO_SRC =
  "https://customer-assets.emergentagent.com/job_network-recognition/artifacts/6w3oqhko_Loudar_logo-invert.jpg";

/**
 * LOUDAR brand mark — uses the official stacked LOU/DAR logo image.
 * Pass `className` to control the height (image scales by height).
 */
export const LoudarLogo = ({ className = "h-10 w-auto", withDot = false }) => {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="loudar-logo">
      <img
        src={LOGO_SRC}
        alt="Loudar"
        className="h-full w-auto object-contain select-none"
        draggable={false}
      />
      {withDot && (
        <span
          aria-hidden
          className="ml-0.5 inline-block h-1.5 w-1.5 rounded-full bg-loudar-orange shadow-[0_0_12px_#ff6b1a]"
        />
      )}
    </div>
  );
};

export default LoudarLogo;
